import { LiquidVariables } from './LiquidVariables';
export const liquidVariables = new LiquidVariables();
